import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { closeOverlay } from '../../actions/overlay';
import { ModalFullwidthFullHeightOverlayContent } from '../container-overlay/styled';
import PageProjectList from "../page-project-list";
const SetProjectsListOverlay = props => {
  const {
    closeOverlay
  } = props;
  return /*#__PURE__*/React.createElement(ModalFullwidthFullHeightOverlayContent, null, /*#__PURE__*/React.createElement(PageProjectList, {
    onCancel: closeOverlay
  }));
};
const mapStateToProps = _ref => {
  let {
    project
  } = _ref;
  return {
    closeOverlay: PropTypes.func.isRequired
  };
};
const mapDispatchToProps = dispatch => ({
  closeOverlay: () => dispatch(closeOverlay())
});
SetProjectsListOverlay.propTypes = {};
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(SetProjectsListOverlay));